import React from "react";
import {NavLink} from "react-router-dom";

export interface LinkProps {
    children?: React.ReactNode;
    className?: string;
    describedby?: string;
    label?: React.ReactNode;
    to?: string;
}

export const Link: React.FC<LinkProps> = ({
    children,
    className,
    describedby,
    label,
    to
}: LinkProps) => {

    if (!label && !children) return <></>;

    return (
        <NavLink to={to!} className={className} aria-describedby={describedby} end>
            {label}
            {children}
        </NavLink>
    );
};
